<template>
  <div>
    <Loading v-if="isLoading" type="1"></Loading>
    <div v-else>
      <div v-if="diskInfos.length > 0">
        <b-row class="font-weight-bold pb-2">
          <b-col cols="3" md="2">{{ "components.servers.name" | i18n }}</b-col>
          <b-col cols="6" md="9">{{
            "components.servers.diskUsage" | i18n
          }}</b-col>
        </b-row>
        <b-row
          align-v="center"
          v-for="disk in diskInfos"
          v-bind:key="disk.id"
          class="pb-3"
        >
          <b-col cols="3" md="2" class="pr-1">{{ disk.chemin }}:/</b-col>
          <b-col cols="8" md="10">
            <b-progress :max="100" height="12px" class="border bg-white">
              <b-progress-bar
                :value="disk.espace_utilise"
                :variant="getColor(disk)"
                class="rounded"
              />
            </b-progress>
          </b-col>
        </b-row>
      </div>
      <div
        id="placeholder"
        class="rounded mb-4 d-flex flex-column text-center justify-content-center"
        v-else
      >
        <div>
          <i class="icon exclamation circle"></i>
        </div>
        <div>
          {{ "components.servers.noDisk" | i18n }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../others/Loading.vue";
/**
 * @description Composante qui décrit un disque d'un serveur
 * @author Benjamin Caron
 * @author Samuel Colassin
 * @vue-prop {Any} serverId - L'id du serveur
 * @vue-data {Array} diskInfos - Les informations du disque
 * @vue-data {Boolean} isLoading - Si la composante est en chargement
 */
export default {
  components: {
    Loading
  },
  props: {
    serverId: {
      required: true
    }
  },
  data() {
    return {
      diskInfos: [],
      isLoading: true
    };
  },
  methods: {
    /**
     * @description Obtient l'état des disques du serveur
     */
    getServerDisksStates() {
      this.$api
        .getServerDisksStates(this.serverId)
        .then(res => {
          if (res.data.data != undefined) {
            this.diskInfos = res.data.data;
            this.isLoading = false;
          }
        })
        .catch();
    },
    /**
     * @description Obtient la couleur de la barre de progression
     * @param {Object} disk Le disque dont on veut obtenir la couleur
     * @returns {String} La couleur de la barre
     */
    getColor(disk) {
      if (disk != undefined) {
        const usedSpace = disk.espace_utilise;
        return usedSpace >= disk.seuil_critique
          ? "danger"
          : usedSpace >= disk.seuil_avertissement
          ? "warning"
          : "success";
      }
    }
  },
  /**
   * @description Obtient l'état de la page avant de charger la page
   */
  beforeMount() {
    this.getServerDisksStates();
  }
};
</script>

<style scoped lang="scss">
#placeholder {
  background: $gray-200;
  height: 7.5em;
}

@media screen and (max-width: 800px) {
  #usage {
    text-align: left !important;
    padding: 0% !important;
  }
}
</style>
